import { Trans } from 'react-i18next';
import { StaticModal, createModal } from '@nexelem/modals';
import { Button } from '@nexelem/components';
import { useCustomTranslation } from '../../../../../hooks';

interface ReassignWorkerModalProps {
  onConfirm: () => void;
  isPending?: boolean;
}

export const ReassignWorkerModal = ({ onConfirm, isPending }: ReassignWorkerModalProps) => {
  const { t, tWrapper } = useCustomTranslation('products.productionPlan.assignWorkerModal');

  return (
    <StaticModal maxWidth="md" onClose={closeReassignWorkerModal}>
      <StaticModal.Header withCloseButton>{tWrapper('confirmationTitle')}</StaticModal.Header>
      <StaticModal.Content className="flex flex-col space-y-6">
        <div className="flex items-start gap-4">
          <span className="text-s18">
            <Trans components={{ strong: <strong /> }}>{tWrapper('confirmationMessage')}</Trans>
          </span>
        </div>
      </StaticModal.Content>
      <StaticModal.Footer className="flex justify-end gap-4">
        <Button variant="outlined" onClick={closeReassignWorkerModal}>
          {t('common.cancel')}
        </Button>
        <Button isLoading={isPending} variant="contained" onClick={onConfirm}>
          {t('common.assign')}
        </Button>
      </StaticModal.Footer>
    </StaticModal>
  );
};

export const { openReassignWorkerModal, closeReassignWorkerModal } = createModal(ReassignWorkerModal, {
  name: 'ReassignWorkerModal',
});
